(function ($, window, _, eventhub, cssCreator) {
	'use strict';
	var getCardType = function (name) {
		if (name && _.isString(name)) {
			return name.substring(0, name.indexOf('_my_methods'));
		}
		return '';
	};
	var _postponeFn = (function IIFE() {
		var timeouts = {};
		return function (fn, timeoutId, ms, arg1, arg2, arg3) {
			clearTimeout(timeouts[timeoutId]);
			timeouts[timeoutId] = setTimeout(function (arg1, arg2, arg3) {
				fn(arg1, arg2, arg3);
			}, ms, arg1, arg2, arg3);
		}
	})();

	var uid = 1;
	var pluginName = 'PMSelectTable';
	var _fastScrollDuration = 50;
	var ghostClickElapsedTime = 100;
	var _lastEventTimestamp;
	var _closeTableProcessing;
	var constants = {
		scrollableClass      : 'scrollable_y',
		iScrollClassName     : 'table_v_scroll',
		pmHolderClassName    : 'table_pms pm-list',
		showMoreBtnClassName : 'show_more',
		showLessBtnClassName : 'show_less',
		hasMoreRowsClassName : 'has_more_rows',
		extractedPmOnlyClassName : 'extracted_only_row', // hide other btn
		openClassName        : 'open',
		updateClassName      : 'open_hidden',
		invisibleClassName   : 'invisible',
		separatorClassName   : 'separator',
		overlayClassName     : 'overlay',
		bodyToggleClassName  : 'overflowed',

		rowClassName: '_tr',
		elmClassName: '_td',

		groupOpenClassName   : 'g_open',
		groupActiveClassName : 'g_active',
		groupRowClassName    : '_g_row',

		groupRowClassOne     : 'one',
		groupRowClassTop     : 'top',
		groupRowClassMiddle  : 'middle',
		groupRowClassBottom  : 'bottom'
	};
	var defaults = {
		enableGrouping       : false,
		isScrollEnabled      : true,
		scrollerSettings     : {
			className        : '.' + constants.iScrollClassName,
			scrollX          : false,
			scrollY          : true,
			mouseWheel       : true,
			scrollbars       : false, // true,
			tap              : true,
			shrinkScrollbars : 'scale'
		},
		pm_order_prefix      : '', // when the plugin is used as a sub gallery
		showUserPMs          : true,
		showMerchantPM       : true,
		drawPmSeparator      : true,
		presentShowMoreForOneRow: false,
		activeElementClass   : 'selected',
		activeRowClass       : 'active',
		pmWrapperClass       : 'pm_table_list',
		remapPmLabel         : {"cc_card": "cc_card", "dc_card": "cc_card"},	// {pmName:msgKey}
		/** extractedPMs = { <pmName>: <uiOrder> },  where <int> uiOrder > 0 **/
		extractedPMs         : {"ppp_ApplePay": 1},	// ~= prioritizePMs 		// {"ppp_ApplePay": 1, "ppp_GooglePay": 2},
		showApplePayInline   : false,
		reduceApplePayPriority : false,
		rowHeight            : '8.1rem',		// Please adjust ( important!!! )
		rowWidthAdjustment   : 0,
		transitionDuration   : 500,
		focusActiveRowOnTableOpen   : false, // true,
		calcItemsPerRowFn    : function (containerWidth, itemWidth) {
			var itemsPerRow = 0;
			if (containerWidth && itemWidth) {
				containerWidth = Math.floor(containerWidth);
				itemWidth = Math.ceil(itemWidth);
				itemsPerRow = (itemWidth && !isNaN(itemWidth) && !isNaN(containerWidth)) ? Math.floor(containerWidth / itemWidth) : 0;
			}
			return itemsPerRow;
		},
		asteriskTemplate     : "*",
		itemContainerTagName : 'td', 		// 'div',
		onClickSelector      : '.' + constants.elmClassName + '[data-wrapper="pms"]',	// '._td[data-wrapper="pms"]',
		allowClickSamePM     : false,
		regExCardPattern     : /\((\d{4})\)|\d\*{4}(\d{4})|\d\*{3}\s+\*{4}\s+\*{4}\s+(\d{4})/,	// matches (1234) and 3****1234 and 1*** **** **** 3567
		mainTemplate         : '<div class="pm-table-wrapper ">' +
			'<%= appleNavElement %><div class="pms list-container">' +
			'<div class="<%-pmWrapperClass%> <%-iScrollClassName%>"><div class="<%-isScrollableClass%> ">' +
				'<div class="table_wrapp">' +
				'<%if(itemContainerTagName == "td"){%> <table class="<%-pmHolderClass%> "></table> ' +
				'<% } else { %>							<ul class="<%-pmHolderClass%> "></ul><%}%> ' +
				'<%= showLessElement %>' +
				'</div>' +
			'</div> </div></div><%= showMoreElement %>' +
		'</div>'
		,
		appleNavTemplate     : '<div class="apple_pay_wrapp hidden">' +
			'<div class="_flex_row">' +
			'</div>' +
			'<p class="or_separator"><span>or</span></p>' +
			'<div class="other">' +
				'<div class="btn_container"><div class="pm-logo other_pms" ></div>' +
				'<div class="text"><%- t("other_pms")%></div></div>' +
			'</div>' +
		'</div>'
		,
		templates            : {
			/** Deprecated props: merchantPMTemplate, userPMTemplate, pmSeparatorRowTemplate  */

			appleNavBtnTemplate:
				'<div class="apple" >' +
					'<div class="btn_container" title="<%-customPmLabel? t(customPmLabel) : label%>">' +
						'<div class="pm-logo ">' +
							'<div class="pm-logo <%-showClass%>"></div>' +
						'</div>' +
						'<div class="text"><%-customPmLabel? t(customPmLabel) : label%></div>' +
					'</div>' +
				'</div>'
			,
			merchantPmContentTemplate :
				'<div class="<%-classPrefix%> pm_container">' +
					'<div class="<%-classPrefix%> pm_side_status"></div>' +
					'<div class="<%-classPrefix%> pm_available" title="<%-customPmLabel? t(customPmLabel) : label%>">' +
						'<div class="pm-logo <%-showClass%>"></div>' +
						'<div class="<%-classPrefix%> pm-details"><%-customPmLabel? t(customPmLabel) : label%></div>' +
					'</div>' +
				'</div>'
			,
			userPmContentTemplate :
				'<div class="<%-classPrefix%> pm_container">' +
					'<div class="<%-classPrefix%> pm_side_status"></div>' +
					'<div class="<%-classPrefix%> pm_available " title="<%- ((details == \'&nbsp;\') ? \'\' : details) %>">' +
						'<div class="upm-logo <%-showClass%>"></div>' +
						'<div class="<%-classPrefix%> pm-details"><%=details%></div>' +
					'</div>' +
				'</div>'
			,
			pmSeparatorRowContentTemplate : '<td class="separator_item" colspan="<%- itemsPerRow %>"></td>',
			fakeItemContentTemplate: '<div class="_fake" ><div class="pm_container"></div></div>',
			showMoreTemplate       : '<div class="<%- className%>"><span><%- t("show_more")%></span></div>',
			showLessTemplate       : '<div class="<%- className%>"><span><%- t("show_less")%></span></div>',
			overlay                : '<div class="<%- className%>"></div>'
		}
	};

	var handleClicks = function (mainElm, options, ctx) {
		var self = ctx;
		var allowClickSamePM = options.allowClickSamePM;
		mainElm.on('click tap', options.onClickSelector, function (evt, data) {
			evt.preventDefault();
			evt.stopPropagation();
			if (_isGhostEvent()) {
				return true;
			}
			var $tdElm = $(evt.target).closest(options._itemSelector);
			var uniqueId = $tdElm.data('value');
			if(!$tdElm.length || !uniqueId){
				return;
			}
			if (self.Groups && self.Groups[uniqueId]) {
				self.onGroupIconClick(uniqueId, $tdElm);
				return;
			}
			var isAlreadySelected = $tdElm.hasClass(options.activeElementClass);
			if (!isAlreadySelected || allowClickSamePM) {
				var dataToSend;
				if (isNaN(parseInt(uniqueId, 10))) {
					dataToSend = self.pm_by_ID[uniqueId];
				} else {
					dataToSend = self.user_pm_by_ID[uniqueId];
				}
				dataToSend.pmPosition = self.order[uniqueId];
				self.updateCurrentState(dataToSend, $tdElm);
				self.showSelected($tdElm);
				eventhub.publish('select-pm', [dataToSend, self, this, data]);
			} else {
				eventhub.publish('select-pm-attempt', [{uniqueId : uniqueId, reason : "already_selected"}, self, this]);
				_closeTable(self, 'handleClicks');
			}
			return false;
		});
	};

	function _normalizePluginOptions(ctx) {
		ctx.options._rowSelector  = '.' + constants.rowClassName;	// '._tr'
		ctx.options._itemSelector = '.' + constants.elmClassName;	// '._td'
		ctx.options._rowTagName   = 'tr'; 							// 'li' | 'tr'
		if (ctx.options.enableGrouping && ctx.options.itemContainerTagName === 'td'){
			ctx.options.itemContainerTagName = 'div';
		}
		if (ctx.options.itemContainerTagName !== 'td') {
			ctx.options._rowTagName = 'li';
			if(ctx.options.templates.pmSeparatorRowContentTemplate === '<td class="separator_item" colspan="<%- itemsPerRow %>"></td>' ){
				ctx.options.templates.pmSeparatorRowContentTemplate = '<div class="separator_item"></div>';
			}
		}
	}

	function Plugin(element, options) {
		options = options || {};
		this.$element = $(element);
		this.options = $.extend(true, {}, defaults, options);
		_normalizePluginOptions(this);
		this.init();

	}

	Plugin.prototype.init = function () {
		var self = this;
		var iScrollClassName = constants.iScrollClassName + '_' + uid;
		cssCreator.setup(this.options.cssCreator);
		this.hasApplePay = false;
		this._extracted = {items: {}, length: 0};
		this.$main_wrapper = $(_getLoTemplate(self, 'mainTemplate')({
			iScrollClassName  : iScrollClassName,
			isScrollableClass : (self.options.isScrollEnabled ? constants.scrollableClass : '' ),
			pmWrapperClass    : self.options.pmWrapperClass,
			pmHolderClass     : constants.pmHolderClassName,
			itemContainerTagName : self.options.itemContainerTagName,
			showMoreClass     : constants.showMoreBtnClassName,
			showMoreElement   : _getLoTemplate(self, 'showMoreTemplate')({className : constants.showMoreBtnClassName}),
			showLessElement   : _getLoTemplate(self, 'showLessTemplate')({className : constants.showLessBtnClassName}),
			appleNavElement   : _getLoTemplate(self, 'appleNavTemplate')()
		}));
		this.$element.append(self.$main_wrapper);
		this.$appleNav = $('.apple_pay_wrapp', self.$main_wrapper);
		this.$appleNavFlexRow = this.$appleNav.find('._flex_row');
		this.$wrapper = $('.' + self.options.pmWrapperClass, self.$main_wrapper);
		this['$pms'] = this.$wrapper.find('.' + constants.pmHolderClassName.split(' ').join('.'));
		this.$overlay = $(_getLoTemplate(self, 'overlay')({className : constants.overlayClassName}));
		this.$main_wrapper.append(this.$overlay);
		this.$wrapper._closedHeight = this.options.rowHeight;
		handleClicks(this.$wrapper, this.options, this);
		if (this.options.isScrollEnabled) {
			var elm = $('.' + iScrollClassName, self.$main_wrapper)[0];
			if (elm) {
				this.iScroll = new IScroll(elm, self.options.scrollerSettings);
			}
		}

		var updateWidth = function (self) {
			self.updateWidth();
			if (self.$main_wrapper.hasClass(constants.openClassName)) {
				_openTable(self);
			}
		};
		$(window).resize(function (e) {
			_postponeFn(updateWidth, 'resize', 50, self);
		});

		if (this.options.showMerchantPM) {
			eventhub.subscribe('pm-available', function (data) {
				self.updateData('pm', data);
			}, this);
		}
		if (this.options.showUserPMs) {
			eventhub.subscribe('user-pm-available', function (data) {
				self.updateData('user_pm', data);
			}, this);
		}
		eventhub.subscribe('dr-select-pm', function (data) {
			var uniqueId = (data.type && data.type === 'int') ? parseInt(data.uniqueId, 10) : data.uniqueId;
			this.handleDR(uniqueId, data.type, data.manual, data.allowApplePayAutoSelect);
		}, this);
		eventhub.subscribe('app.event.PMSelectTable.unselectPM', function () {
			self.unselect();
		});
		_addAppleNavEvents(self);
		_addMainWrapperEvents(self);
	};

	Plugin.prototype.selectApplePay = function (manual) {
		var self = this;
		if (self.hasApplePay) {
			var $targetElm = $('.apple[data-value="ppp_ApplePay"]', self.$main_wrapper);
			var $el = $(self.options.itemContainerTagName + '[data-value="ppp_ApplePay"]', self.$main_wrapper);

			if ($targetElm.length) {
				$targetElm.trigger('click', manual);
			} else if(self.options.showApplePayInline && $el.length) {
				$($el).trigger('click', manual);
			}
			return true;
		}
	};

	Plugin.prototype.refreshScroll = function (go_top, duration, $row) {
		var self = this;
		if (self.iScroll) {
			self.iScroll.refresh();
			if (go_top) {
				self.iScroll.scrollTo(0, 0, _fastScrollDuration);
			} else {
				var a = $row || self.$wrapper.find('.' + self.options.activeRowClass);
				if (a.length) {
					self.iScroll.scrollToElement(a[0], (duration || _fastScrollDuration), 0, 0);
				} else {
					self.iScroll.scrollTo(0, 0, _fastScrollDuration);
				}
			}
		}
	};

	Plugin.prototype.unselect = function (preventStateUpdate) {
		this.$wrapper.find('.' + this.options.activeElementClass).removeClass(this.options.activeElementClass);
		this.$wrapper.find('.' + this.options.activeRowClass).removeClass(this.options.activeRowClass);
		this.$appleNav.find('.' + this.options.activeElementClass).removeClass(this.options.activeElementClass);

		if(!preventStateUpdate){
			this.updateCurrentState();
		}
	};

	Plugin.prototype.showSelected = function ($elm) {
		var self = this;
		var uniqueId = $elm.data('value');
		var data_type = $elm.data('type');
		var $row = $elm.closest(self.options._rowSelector + '[data-type="' + data_type + '"]');
		if (self.options.extractedPMs &&  self.options.extractedPMs[uniqueId]) {
			/** Fix visible gallery row if Apple is selected **/
			$row = self.$wrapper.find('.' + self.options.activeRowClass);
			if (!$row.length) {
				$row = _getFirstMeaningfulRow(self);
			}
		} else {
			_revealGallery(self, 'showSelected');
		}
		self.unselect(true);
		$elm.addClass(self.options.activeElementClass);
		$row.addClass(self.options.activeRowClass);

		if (self.options.enableGrouping) {
			var groupId = (self.selected && self.selected.groupId);
			if(groupId && self.Groups[groupId] && !self.Groups[groupId].isOpen){
				self.openGroup(groupId)
			}
		}
		_closeTable(self, 'showSelected');
	};

	function _revealGallery(self, caller){
		self.$appleNav.addClass('show_gallery');
		self.$wrapper.removeClass(constants.invisibleClassName);
	}

	Plugin.prototype.handleDR = function (uniqueId, idType, manual, allowApplePayAutoSelect) {
		var self = this;
		var $el;
		var hasUpos = self.options.user_pm_data && self.options.user_pm_data.length;
		var doAppleAutoSelect = self.hasApplePay && allowApplePayAutoSelect && (!hasUpos || !self.options.reduceApplePayPriority);
		if (self.hasApplePay && (uniqueId === "ppp_ApplePay" || doAppleAutoSelect)) {
			self.selectApplePay(manual);
			return;
		} else if (self._extracted.items[uniqueId] && self.pm_by_ID && self.pm_by_ID[uniqueId]) {
			$el = self.$appleNav.find(self.options._itemSelector + '[data-value=' + uniqueId + ']');;
		} else if (uniqueId === "auto_select" && idType === "auto_select") {
			$el = self.$wrapper.find(self.options.onClickSelector).first();
		} else if (uniqueId === "auto_select" && idType === "pm") {
			$el = self.$wrapper.find(self.options._itemSelector + '[data-value][data-type="pm"]').first();
		} else if (idType === 'int' && self.user_pm_by_ID && self.user_pm_by_ID[uniqueId] || self.pm_by_ID && self.pm_by_ID[uniqueId]) {
			$el = self.$wrapper.find(self.options._itemSelector + '[data-value=' + uniqueId + ']');
		}
		if ($el && $el.length) {
			$el.trigger('click', manual);
		} else {
			eventhub.publish('select-pm-attempt', [{uniqueId : uniqueId, reason : "incorrect_id"}, self, this]);
		}
	};

	Plugin.prototype.updateGroupsDomRef = function () {
		var self = this;
		if (self.options.enableGrouping && self.Groups) {
			_.each(self.Groups, function (group) {
				if (group) {
					group.$elm = self.$wrapper.find(self.options._itemSelector + '[data-value="' + group.uniqueId + '"]');
					group.$elms = self.$wrapper.find(self.options._itemSelector + '[data-group="' + group.uniqueId + '"]');
					group.$rows = self.$wrapper.find(self.options._rowSelector + '[data-group_holder="' + group.uniqueId + '"]');
				}
			});
		}
	};

	Plugin.prototype.closeAllGroups = function () {
		var self = this;
		if (self.Groups) {
			var changed = false;
			_.each(self.Groups, function (group, groupId) {
				if (group.isOpen) {
					changed = true;
					group.isOpen = false;
					group.$elm.removeClass(constants.groupOpenClassName);
					group.$rows.addClass('hidden');
					// self.Groups[groupId].$elms.addClass('hidden');
				}
			});
			if (changed && self.iScroll) {
				self.iScroll.refresh();
			}
		}
	};

	Plugin.prototype.closeGroup = function (groupId) {
		var self = this;
		var selectedGroupId = (self.selected && self.selected.groupId);
		if (groupId && self.Groups && self.Groups[groupId] && self.Groups[groupId].isOpen && groupId !== selectedGroupId) {
			self.Groups[groupId].isOpen = false;
			self.Groups[groupId].$elm.removeClass(constants.groupOpenClassName);
			self.Groups[groupId].$rows.addClass('hidden');	// ROWS
			// self.Groups[groupId].$elms.addClass('hidden');
			/** make sure the selected item is visible when possible:
			 * since it is possible to close even a group containing a selected element
			 * to represent the contents of another group - when closing the second one
			 * we have to restore the open state of the group with the selected element.
			 * **/
			if (selectedGroupId) {
				self.openGroup(selectedGroupId);
			} else if (self.iScroll) {
				self.iScroll.refresh();
			}
		}
	};

	Plugin.prototype.openGroup = function (groupId) {
		var self = this;
		if (groupId && self.Groups && self.Groups[groupId] && !self.Groups[groupId].isOpen) {
			self.closeAllGroups();
			self.Groups[groupId].isOpen = true;
			self.Groups[groupId].$elm.addClass(constants.groupOpenClassName);
			self.Groups[groupId].$rows.removeClass('hidden');
			// self.Groups[groupId].$elms.removeClass('hidden');
			if (self.iScroll) {
				self.iScroll.refresh();
			}
		}
	};

	Plugin.prototype.onGroupIconClick = function (groupId, $groupElm) {
		var self = this;
		if (groupId && self.Groups[groupId] && self.Groups[groupId].pm_list.length) {
			var isGalleryOpen = self.$main_wrapper.hasClass(constants.openClassName);
			if(isGalleryOpen) {
				var isGroupOpen = $groupElm && self.Groups[groupId].isOpen;
				if (!isGroupOpen) {
					self.openGroup(groupId);
				} else {
					self.closeGroup(groupId);
				}
			} else {
				/** when Gallery_is_closed and user selects a group icon **/
				_openTable(self);
				self.openGroup(groupId);
				self.refreshScroll(false, self.options.transitionDuration, self.Groups[groupId].$elm);
			}
		}
	};

	Plugin.prototype.updateCurrentState = function (data, elm) {
		var self = this;
		if (data) {
			self.selected = $.extend(true, {}, data);
			self.selected.$elm = elm;
			self.selected.$groupElm = self.Groups && data.groupId && self.Groups[data.groupId] && self.Groups[data.groupId].$elm;
		} else {
			self.selected = {};
		}
	};

	Plugin.prototype.updateWidth = function () {
		var self = this;
		var uniqueId = self.$wrapper.find(self.options._itemSelector + "." + self.options.activeElementClass).data('value');

		self.$main_wrapper.addClass(constants.updateClassName);
		var totalLength = 0;
		// var containerWidth = Math.floor(self.$wrapper.outerWidth(false)) - self.options.rowWidthAdjustment;
		var containerWidth = Math.floor(self.$wrapper.width()) - self.options.rowWidthAdjustment;
		var itemsCollection = self.$wrapper.find(self.options._itemSelector + ' .pm_container');

		itemsCollection.each(function () {
			totalLength += $(this).outerWidth(true);
		});
		var itemWidth = Math.ceil(totalLength / itemsCollection.length);
		var _itemsPerRow = self.options.calcItemsPerRowFn(containerWidth, itemWidth) || self._itemsPerRow;
		if (self._itemsPerRow !== _itemsPerRow) {
			self._itemsPerRow = _itemsPerRow;
			self.render("pm");
			self.render("user_pm");

			if (uniqueId) {
				/** restore selected item **/
				self.unselect(true);
				var $elm = self.$wrapper.find(self.options._itemSelector + '[data-value="' + uniqueId + '"]');
				var $parentRow = $elm.closest(self.options._rowSelector + '[data-type="' + $elm.data('type') + '"]');
				$elm.addClass(self.options.activeElementClass);
				$parentRow.addClass(self.options.activeRowClass);
				self.updateCurrentState(self.selected, $elm);

				if (self.options.enableGrouping) {
					self.closeAllGroups();
					var selectedGroupId = (self.selected && self.selected.groupId);
					if (selectedGroupId && self.Groups[selectedGroupId]) {
						self.openGroup(selectedGroupId);
					}
				}
			}
		}
		self.$main_wrapper.removeClass(constants.updateClassName);
		self.refreshScroll();
	};

	Plugin.prototype.render = function (data_type) {
		var self = this;
		var currentData = self.options[data_type + '_data'];
		var currentListElm = self['$pms'];
		if (!currentListElm || !currentData) {
			return;
		}
		currentListElm.find(self.options._rowSelector + '[data-type="' + data_type + '"]').remove();

		if (data_type === 'pm') {
			self._extracted.items = {};
			self._extracted.length = 0;
		}
		var totalLen = 0;
		var docFragment = $(document.createDocumentFragment());

		_listItems(docFragment, currentData, data_type);
		if (data_type === 'pm' && totalLen) {
			_appendSeparator(currentListElm);
			currentListElm.append(docFragment);
		} else if (data_type === 'user_pm' && totalLen) {
			currentListElm.prepend(docFragment);
		}
		if (data_type === 'pm') {
			self.updateGroupsDomRef();
		}
		_renderExtractedItems();
		_handleShowMoreBtn(self);
		if (self.iScroll) {
			self.iScroll.refresh();
		}

		/*** render helpers Start ***/
		function _listItems(parentElm, data, dataType, memberOfGroupId) {
			var $row;
			var len = 0;
			var rows = 0;
			var gRows = memberOfGroupId && data.length && (Math.ceil(data.length / self._itemsPerRow)) || 0;
			var itemContentTemplate = _getLoTemplate(self, (dataType === 'pm' ? 'merchantPmContentTemplate' : 'userPmContentTemplate'));

			_.each(data, function (item, idx, arr) {
				switch (dataType) {
					case 'user_pm':
						item.hasNoClass = !cssCreator.makeRule(item.showClass);
						break;
					case 'pm':
						item.hasNoClass = (item.name === 'cc_card' || item.name === 'dc_card') ? false : !cssCreator.makeRule(item.name.toLowerCase());
						break;
				}
				if (dataType === 'pm' && self.options.extractedPMs && self.options.extractedPMs[item.uniqueId] && !(item.uniqueId === 'ppp_ApplePay' && self.options.showApplePayInline)) {
					/** save the Item for later rendering **/
					self._extracted.items[item.uniqueId] = item;
					self._extracted.length++;
				} else {
					totalLen++;
					var rowExtraClassName = memberOfGroupId ? _getGroupRowExtraClassName(gRows, rows) : '';

					/** ensure that we do not render grouped items
					 *  unless the function call is explicitly to them **/
					if (memberOfGroupId || !item.groupId) {
						if (!$row || (len && (len % self._itemsPerRow) == 0)) {
							$row = _renderRow(dataType, memberOfGroupId, rowExtraClassName);
							parentElm.append($row);
							rows++;
						}
						var elm = _renderItem(item, dataType, itemContentTemplate);
						$row.append(elm);
						len++;
					}
					if (item.isPmGroup && item.pm_list) {
						var df2 = $(document.createDocumentFragment());
						_listItems(df2, item.pm_list, dataType, item.uniqueId);
						parentElm.append(df2);
						elm.attr('data-items', item.pm_list.length)
							.addClass('pms_wrap_' + item.pm_list.length);
					}
				}
			});
			_fulfilRow($row, len, _getLoTemplate(self, 'fakeItemContentTemplate'));
		}

		function _renderItem(item, dataType, itemContentTpl) {
			var $container = $('<' + self.options.itemContainerTagName + '>');
			$container
				.attr('data-value', item.uniqueId)
				.attr('data-type', dataType)
				.attr('data-wrapper', "pms")
				.addClass(constants.elmClassName);
			if (item.groupId) {
				$container.attr('data-group', item.groupId);	// .addClass('hidden');
			}
			if (item.isPmGroup) {
				$container.addClass('pm_group');
			}
			if (item.promotedPM) {
				$container.addClass("promotedPM");
			}
			return $container.append(itemContentTpl(item));
		}

		function _renderRow(dataType, groupId, classes) {
			var $row = $('<' + self.options._rowTagName + '>');
			$row.attr('data-type', dataType)
				.addClass(constants.rowClassName + ' ' + classes);
			if (groupId) {
				$row.attr('data-group_holder', groupId)
					.attr('data-role', 'groupItemsHolder')
					.addClass(constants.groupRowClassName)
					.addClass('hidden');
			}
			return $row;
		}

		function _fulfilRow($rowElm, itemsLength, tpl) {
			var dif = (itemsLength % self._itemsPerRow);
			if ($rowElm && dif > 0) {
				var f_content = tpl();
				for (var i = (self._itemsPerRow - dif); i > 0; i--) {
					var $fElm = $('<' + self.options.itemContainerTagName + '>');
					$fElm.attr('data-f', "xxx").addClass(constants.elmClassName);
					$fElm.append(f_content);
					$rowElm.append($fElm);
				}
			}
		}

		function _appendSeparator(parent) {
			if (self.options.showUserPMs && self.options.drawPmSeparator) {
				var $row = _renderRow('pm', null, constants.separatorClassName);
				var $content = $(_getLoTemplate(self, 'pmSeparatorRowContentTemplate')({itemsPerRow: self._itemsPerRow}));
				$content.addClass(constants.elmClassName);
				$row.append($content);
				parent.append($row);
			}
		}

		function _renderExtractedItems() {
			if (self.$appleNavFlexRow.length && self._extracted.length) {
				self.$appleNavFlexRow.empty()
				var tpl = _getLoTemplate(self, 'appleNavBtnTemplate');
				var keys = Object.keys(self._extracted.items).sort(function (k1, k2) {
					return self.options.extractedPMs[k1] - self.options.extractedPMs[k2];
				});
				_.each(keys, function (k, idx) {
					var item = self._extracted.items[k];
					var $btn = $(tpl(item))
						.attr('data-value', item.uniqueId)
						.attr('data-type', item.data_type)
						.attr('data-wrapper', "pms")
						.addClass(constants.elmClassName);
					self.$appleNavFlexRow.append($btn);
				});
			}
		}

		function _getGroupRowExtraClassName(groupRows, rowIdx) {
			if (groupRows === 1) {
				return constants.groupRowClassOne;
			} else if (groupRows > 1 && 0 === rowIdx) {
				return constants.groupRowClassTop;
			} else if (groupRows > 1 && groupRows === rowIdx + 1) {
				return constants.groupRowClassBottom;
			}
			return constants.groupRowClassMiddle;
		}
		/*** render helpers End ***/
	};

	Plugin.prototype.updatePmPosition = function () {
		var self = this;
		var order = {};
		var items = self.$wrapper.find(self.options._itemSelector + '[data-value]');
		_findOrder(items, self.options.pm_order_prefix);
		if(self._extracted.length){
			var extracted = self.$appleNav.find(self.options._itemSelector + '[data-value]');
			_findOrder(extracted, self.options.pm_order_prefix ? self.options.pm_order_prefix + '.0': '0', '0' );
		}
		self.order = order;

		function _findOrder(items, prefix, subPrefix) {
			prefix = prefix ? prefix + "." : '';
			subPrefix = subPrefix ? subPrefix + "." : '';
			var count = 0;
			var giCount = 0;
			var upoCount = 0;
			var arr = items.toArray();
			_.each(arr, function (item, idx) {
				var $i = $(item);
				var id = $i.attr("data-value");
				var isUpo = $i.attr("data-type") === "user_pm";
				var groupItem = $i.attr("data-group");
				var pos, subPos;
				if (isUpo) {
					pos = prefix + (++count);
					subPos = '' + (++upoCount);
				} else if (groupItem) {
					pos = order[groupItem].absolute + "." + (++giCount);
					subPos = order[groupItem].relative + "." + giCount;
				} else {
					pos = prefix + (id === 'ppp_ApplePay' && !self.options.showApplePayInline ? '0' : ++count);
					subPos = subPrefix + (id === 'ppp_ApplePay' && !self.options.showApplePayInline ? '0' : count - upoCount);
					giCount = 0;
				}
				order[id] = {absolute: pos, relative: subPos};
			});
		}
	};

	Plugin.prototype.updateData = function (data_type, data) {
		var self = this;
		var currentData = null;
		data = data || [];
		var myData = $.extend(true, [], data);
		if (data_type === "pm") {
			currentData = self.pm(myData);
		} else if (data_type === "user_pm") {
			currentData = self.userPM(myData);
		}
		self.options[data_type + '_data'] = currentData;
		self.render(data_type);
		if (data_type === "pm") {
			_handleAppleNavClasses(self);
		}
		self.updateWidth();
		self.updatePmPosition();

		eventhub.publish('app.event.PMSelectTable.postRender', [{data_type : data_type}]);
		eventhub.publish('app.event.gallery.postRender', [{data_type: data_type, plugin: 'pmselecttable'}]);
	};

	function _createGroup(item) {
		return {
			uniqueId     : item.groupId,
			label        : item.groupLabel,
			name         : item.groupLabel,
			showClass    : (item.groupShowClass || item.groupLabel).toLowerCase(),
			isPmGroup    : true,
			isIframe     : false,
			details      : '',
			customPmLabel: '',
			data_type    : 'pm',
			classPrefix  : 'pm',
			pm_list      : [],
			$elm         : false,
			$elms        : false,
			$rows        : false,
			groupId      : false,
			isOpen		 : false,
			rawData      : {}
		}
	}

	Plugin.prototype.pm = function (merchantPMArray) {
		var self = this;
		var retObj = {};
		var pm_by_ID = self.pm_by_ID = {};
		self.hasApplePay = false;
		self.Groups = {};
		self.count_pm = 0;

		_.each(_.map(merchantPMArray, function (item) {
			var iframe = null;
			if (item.attributes && _.has(item.attributes, 'isIframe')) {
				iframe = item.attributes.isIframe;
			}
			var showClass = item.value || '';
			showClass = showClass.toLowerCase();
			var details = "";
			var fee = item.attributes.customFees || {};
			if (showClass === 'ppp_applepay') {
				self.hasApplePay = true;
			}
			if (item.groupId && !self.Groups[item.groupId]) {
				self.Groups[item.groupId] = _createGroup(item);
			}
			self.count_pm++;
			var newItem = {
				uniqueId     : item.value,
				label        : item.label,
				name         : showClass,
				isIframe     : iframe,
				showClass    : showClass,
				details      : details || '',
				feeValue     : fee.feeValue,
				feeValueType : fee.feeValueType,
				feeType      : fee.feeType,
				feeMinValue  : fee.feeMinValue,
				feeMaxValue  : fee.feeMaxValue,
				promotedPM	 : item.attributes && item.attributes.promotedPM,
				data_type    : 'pm',
				classPrefix  : 'pm',
				customPmLabel: self.options.remapPmLabel[item.value] || '',
				rawData      : item || {},
				groupId      : self.options.enableGrouping && item.groupId
			};
			pm_by_ID[newItem.uniqueId] = newItem;
			return newItem;
		}), function (elm) {
			if (self.options.enableGrouping && elm.groupId && self.Groups[elm.groupId]) {
				if (!retObj[elm.groupId]) {
					retObj[elm.groupId] = self.Groups[elm.groupId];
				}
				retObj[elm.groupId].pm_list.push(elm);
			}
			retObj[elm.uniqueId] = elm;
		});
		return retObj;
	};

	Plugin.prototype.userPM = function (userPMArray) {
		var self = this;
		var ccCardDetails = this.options.regExCardPattern;
		var user_pm_by_ID = this.user_pm_by_ID = {};
		self.count_upm = 0;
		return _.map(userPMArray, function (item) {
			var iframe = null;
			var showClass = null;
			var details = "";
			var fee = item.customFees || {};
			var issuer = item.cardIssuer;

			if (item.attributes && _.has(item.attributes, 'isIframe')) {
				iframe = item.attributes.isIframe;
			}
			if (ccCardDetails.test(item.name)) {
				details = self.options.asteriskTemplate + (item.name.match(ccCardDetails)[1] || item.name.match(ccCardDetails)[2] || item.name.match(ccCardDetails)[3]);
				showClass = item.type || item.card_type || getCardType(item.className) || item.paymentOptionName;
				issuer = issuer || showClass;
				// Hack for WD
				if (item.paymentOptionName === "visa_checkout") {
					showClass = item.paymentOptionName;
				}
			} else {
				showClass = item.paymentOptionName || item.type || item.card_type || getCardType(item.className);
				details = item.name;
				issuer = issuer || item.displayPaymentOptionName;
			}
			showClass = showClass.toLowerCase();
			self.count_upm++;
			var newItem = {
				uniqueId     : parseInt(item.userPaymentOptionId, 10) || -1,
				label        : item.displayPaymentOptionName || '',
				name         : item.paymentOptionName || '',
				isIframe     : iframe,
				showClass    : showClass,
				details      : details || '&nbsp;',
				feeValue     : fee.feeValue,
				feeValueType : fee.feeValueType,
				feeType      : fee.feeType,
				rawData      : item || {},
				issuer       : issuer,
				data_type    : 'user_pm',
				classPrefix  : 'upm',
				netDeposit   : item.netDepositValue || ''
			};
			user_pm_by_ID[newItem.uniqueId] = newItem;
			return newItem;
		});
	};

	function _isGhostEvent() {
		var currentTime = (new Date()).getTime();
		var isGhost = (currentTime - _lastEventTimestamp < ghostClickElapsedTime);
		_lastEventTimestamp = currentTime;
		return isGhost;
	}

	function _getFirstMeaningfulRow(self) {
		var $row = self.$wrapper.find(self.options._rowSelector).first();
		if ($row.hasClass(constants.separatorClassName)) {
			$row = $row.next();
		}
		return $row;
	}

	function _addMainWrapperEvents(self) {
		var selectors = ['.', constants.overlayClassName, ', .', self.options.pmWrapperClass].join('');
		self.$main_wrapper.on('click tap', selectors, function (e) {
			if (_isGhostEvent()) {
				return true;
			}
			_closeTable(self, '$main_wrapper_click');
		});

		self.$main_wrapper.on('click', '.' + constants.showMoreBtnClassName, function (e) {
			if (_isGhostEvent() || self.$main_wrapper.hasClass(constants.openClassName)) {
				return;
			}
			_openTable(self);
		});
	}

	function _addAppleNavEvents(self) {
		handleClicks(
			self.$appleNav, {
				onClickSelector      : ".apple",
				allowClickSamePM     : self.options.allowClickSamePM,
				_itemSelector 		 : '.apple[data-value]',
				activeElementClass   : self.options.activeElementClass,
				rowHeight            : self.options.rowHeight
			},
			self);
		self.$appleNav.one('click tab', ".other", function (e) {
			self.$appleNav.addClass('show_gallery');
			self.$wrapper.find('.' + self.options.activeRowClass).removeClass(self.options.activeRowClass);
			self.$wrapper.removeClass(constants.invisibleClassName);
			_getFirstMeaningfulRow(self).addClass(self.options.activeRowClass);
		});
	}

	function _handleShowMoreBtn(self) {
		var min_pm_rows = self.options.drawPmSeparator ? 2 : 1;
		var pm_len = self.count_pm || 0;
		var upm_len = self.count_upm || 0;
		var itemsPerRow = self._itemsPerRow || 1;
		pm_len = pm_len - self._extracted.length;
		if (self.options.presentShowMoreForOneRow) {
			self.$main_wrapper.addClass(constants.hasMoreRowsClassName).removeClass(constants.extractedPmOnlyClassName);
		} else if ((pm_len + upm_len) / itemsPerRow > 1 || (pm_len > 0 && upm_len > 0)) {
			self.$main_wrapper.addClass(constants.hasMoreRowsClassName).removeClass(constants.extractedPmOnlyClassName);
		} else if (self.options.enableGrouping && !upm_len && self.$wrapper.find(self.options._rowSelector).length > min_pm_rows) {
			self.$main_wrapper.addClass(constants.hasMoreRowsClassName).removeClass(constants.extractedPmOnlyClassName);
		} else {
			self.$main_wrapper.removeClass(constants.hasMoreRowsClassName);
			if (pm_len + upm_len === 0 && self._extracted.length) {
				self.$main_wrapper.addClass(constants.extractedPmOnlyClassName);
				_revealGallery(self, 'handleShowMoreBtn');
			}
		}
		if ((pm_len + upm_len) && !self.$wrapper.find('.' + self.options.activeRowClass).length) {
			_getFirstMeaningfulRow(self).addClass(self.options.activeRowClass);
		}
	}

	function _openTable(self, skipClasses) {
		if(!skipClasses){
			$('body').addClass(constants.bodyToggleClassName); 		// 'overflowed'
			self.$main_wrapper.addClass(constants.openClassName); 	// 'open'
		}
		var winHeight = $(window).height();
		var maxHeight = winHeight - self.$wrapper.offset().top;
		self.refreshScroll(true);
		self.$wrapper.stop().animate(
			{height : maxHeight},
			self.options.transitionDuration,
			"linear",
			function () {
				if (self.iScroll) {
					self.iScroll.enable();
					if(self.options.focusActiveRowOnTableOpen) {
						self.refreshScroll(false, self.options.transitionDuration);
					} else {
						self.iScroll.refresh();
					}
				}
			});
	}

	function _closeTable(self, caller, calls_count) {
		var a, count = calls_count || 1;
		if ((count < 5 && _closeTableProcessing) || (self.iScroll && (self.iScroll.isInTransition || self.iScroll.isAnimating))) {
			_postponeFn(_closeTable, 'closeTable', 50, self, caller, ++count);
			return;
		}
		a = self.$wrapper.find('.' + self.options.activeRowClass);
		_closeTableProcessing = true;
		if (self.$wrapper.height() !== self.$wrapper._closedHeight || self.$main_wrapper.hasClass(constants.openClassName)) {
			// console.log('The gallery is OPEN; caller:', caller, '; hasActiveRow:', a.length);
			var a_h = a.height();
			var v_r = Math.min(Math.round(self.$wrapper.height() / a_h), self.$wrapper.find('tr').length);
			var dpr = Math.max(Math.round(self.options.transitionDuration / 6), _fastScrollDuration);
			var duration = (v_r > 1) ? v_r * dpr : 30;  // console.log("duration", duration);
			var wot = self.$wrapper.offset().top;
			var s_time;
			self.$wrapper.stop().animate(
				{
					height : self.options.rowHeight
				},
				{
					duration : duration,
					easing   : "linear",
					start    : function (x) {
						s_time = (new Date()).getTime();
						if (self.iScroll) {
							self.iScroll.disable();
						}
					},
					step     : function (now, fx) {
						if (a.length) {
							var _dif = wot + self.$wrapper.height() - a_h;
							if (self.iScroll && a.offset().top > _dif) {
								var time = duration + s_time - (new Date()).getTime();	// console.log('time', time);
								self.iScroll.refresh();
								if (time > 0) {
									self.iScroll.scrollToElement(a[0], time, 0, 0);
								} else {
									self.iScroll.scrollToElement(a[0], 0, 0, 0);
								}
							}
						}
					},
					complete : function () {    // console.log("end", (new Date()).getTime() - s_time);
						$('body').removeClass(constants.bodyToggleClassName);
						self.$main_wrapper.removeClass(constants.openClassName);

						self.$wrapper._closedHeight = self.$wrapper.height();
						/** make sure the selected item is visible when possible */
						if (self.selected && self.selected.groupId) {
							self.openGroup(self.selected.groupId);
						}
						if (self.iScroll) {
							self.iScroll.refresh();
							setTimeout(function () {
								self.iScroll.refresh();
								if (a.length) {
									self.iScroll.scrollToElement(a[0], _fastScrollDuration, 0, 0);  //  console.log("ANIMATION COMPLETE => scrollToElement:", a[0], "; caller:", caller);
								}
								_closeTableProcessing = false;
							}, 16);
						}
					}
				}
			);
		} else {    // console.log('The gallery is closed', caller, a[0]);
			self.$wrapper.finish();
			if (self.iScroll) {
				self.iScroll.refresh();
				if (a.length) {
					self.iScroll.scrollToElement(a[0], _fastScrollDuration, 0, 0);
				}
				var doScroll = function (self, caller) {
					if (self.iScroll) {
						if (self.iScroll.isInTransition || self.iScroll.isAnimating) {
							_postponeFn(doScroll, 'scrollTo', _fastScrollDuration + 10, self, caller);
							return;
						}
						self.iScroll.refresh();
						var a = self.$wrapper.find('.' + self.options.activeRowClass);
						if (a.length) {
							self.iScroll.scrollToElement(a[0], _fastScrollDuration, 0, 0);  // console.log("POSTPONE => scrollToElement:", a[0], "; caller:", caller);
						}
					}
					_closeTableProcessing = false;
				};
				_postponeFn(doScroll, 'scrollTo', 16, self, caller);
			} else {
				_closeTableProcessing = false;
			}
		}
	}

	function _getLoTemplate(self, tpl_name) {
		var tpl = false;
		if (self && tpl_name) {
			if (self.options && self.options.templates && self.options.templates[tpl_name]) {
				tpl = self.options.templates[tpl_name];

			} else if (self.options && self.options[tpl_name]) {
				tpl = self.options[tpl_name];
			}
			if (tpl && _.isString(tpl)) {
				tpl = _.template(tpl);
			}
		}
		return tpl;
	}

	function _handleAppleNavClasses(self) {
		if (self._extracted && self._extracted.length) {
			self.$main_wrapper.addClass('withApplePay');
			self.$appleNav.removeClass('hidden');
			if (!self.$appleNav.hasClass('show_gallery')) {
				self.$wrapper.addClass(constants.invisibleClassName);
			}
		} else {
			self.$main_wrapper.removeClass('withApplePay');
			self.$wrapper.removeClass(constants.invisibleClassName);
			self.$appleNav.addClass('hidden');
		}
	}

	/**
	 * Plugin initialization
	 * @param options
	 * @returns {*}
	 */
	$.fn[pluginName] = function (options) {
		return this.each(function () {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new Plugin(this, options));
				uid += 1;
			}
		});
	};
})(jQuery, window, _, pubsub, cssCreator);